import styles from './JeeDashboard.module.css'
import HighFi from '../../../assets/hifiIcon.png'
import ExamCard from './ExamCard'
import Branchmapsection from 'components/branchDetails/branch_map_section'
import Byjus_Advantage from 'components/MoreInfoSection/byjus_advantage'
import LockGreen from '../../../assets/LockGreen.svg'
import LockGolden from '../../../assets/LockGolden.svg'
import LockGray from '../../../assets/LockGray.svg'
import DownArrow from '../../../assets/DownArrow.svg'
import { useEffect, useState } from 'react'
import PaperCard from './PaperCard'
import Calendar from '../../../components/Calendar'
import { view_drop_click, dashboard_load_fail } from 'utils/customWebengage'

import calendarImage from '../../../assets/calendar.png'
import Faq from 'components/MoreInfoSection/faq'
import CONFIG from 'config'
import useGetApi from 'api/useGetApi'
import { SunspotLoader } from 'react-awesome-loaders'
import { DateMonthYear, getExamType } from 'utils/common'

const JeeDashboard = ({ profileData, token }) => {
    const examType = getExamType()

    const [isLoading, setIsLoading] = useState(false)

    const { data: responseData, isLoading: isApiLoading } = useGetApi(
        CONFIG.DASHBOARD_API,
        token,
        true,
    )

    useEffect(() => {
        setIsLoading(isApiLoading || !responseData)
    }, [isApiLoading, responseData])

    useEffect(() => {
        if (responseData === null || '') {
            setIsLoading(true)
        } else {
            setIsLoading(false)
        }
    }, [isLoading, responseData])

    const [isCalendarVisible, setIsCalendarVisible] = useState(false)
    const mainExam = responseData?.data?.main_exam
    const firstUpcoming =
        mainExam && Array.isArray(mainExam)
            ? mainExam.findIndex((exam) => exam.status === 'Upcoming') > 0
                ? false
                : mainExam.findIndex((exam) => exam.status === 'Upcoming')
            : -1

    const isFinished = mainExam?.some((exam) => exam.status === 'Results')
    const today = new Date().toISOString().split('T')[0]
    const currentTime = new Date().toLocaleTimeString()

    const currentSeries = mainExam?.find((exam) => {
        if (exam.exam_date === today || exam.status === 'Ongoing') {
            return exam.papers.find((paper) => currentTime >= paper.start_time)
        }
        return false
    })

    const hasPastExams = mainExam?.some((exam) => exam.exam_date < today)
    const studentName =
        profileData.student_firstname +
        ' ' +
        (profileData.student_lastname != null ? profileData.student_lastname : '')

    useEffect(() => {
        setTimeout(() => {
            if (!studentName || studentName == '')
                dashboard_load_fail(
                    '15_Dashboard_Load_Failure',
                    profileData,
                    examType,
                )
        }, 4000)
    }, [studentName])

    const examDates = mainExam?.map((exam) => ({
        date: exam.exam_date,
        status: exam?.status?.toLowerCase(),
    }))

    const handleStickyClick = () => {
        setIsCalendarVisible(!isCalendarVisible)
    }

    const Bookmark = () => {
        return (
            <div className={styles.bookMarkContainer}>
                <h2>Bookmark this dashboard!</h2>
                <p>
                    Press <span>Ctrl + D </span>
                    (Windows) or <span>Cmd + D</span> (Mac)
                </p>
                <span>Save this page for quick access to your tests!</span>
            </div>
        )
    }

    // has name, date and calender
    const InfoBoard = ({ username, dateObj }) => {
        const currentDate = new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        })

        return (
            <div className={styles.boardContainer}>
                <p>{currentDate}</p>
                <h2>
                    Welcome,
                    <br /> {username}! <img src={HighFi} alt="hifi" />
                </h2>
                <p>Always stay updated</p>
                <div className={styles.calenderContainer}>
                    Test series calendar
                    <Calendar
                        dateObj={dateObj}
                        currentDate={new Date()}
                        profile={profileData}
                    />
                </div>
                <div className={styles.video}>
                    <iframe
                        width="100%"
                        height="120"
                        src="https://www.youtube.com/embed/-GZTlL26Zp4"
                        title="Video_player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                    {/* <Byjus_Advantage token={token} profileData={profileData} /> */}
                </div>
            </div>
        )
    }

    // individual cards
    const TestCard = ({ heading, date, status, papers, token, firstUpcoming }) => {
        const formattedDate = DateMonthYear(date) // Renaming 'date' to 'formattedDate'

        const [isExpanded, setIsExpanded] = useState(false)
        const lockTypes = {
            Upcoming: LockGolden,
            Missed: LockGray,
            Results: LockGreen,
            Ongoing: LockGolden,
        }
        const buttonStyles = {
            Missed: {
                color: '#FA0505',
            },
            Results: {
                color: '#262626',
            },
            Upcoming: {
                color: '#262626',
            },
            Ongoing: {
                color: '#262626',
            },
        }

        const IconStyles = {
            Missed: {
                backgroundColor: '#E9ECEF',
            },
            Results: {
                backgroundColor: '#EDF7EE',
            },
            Upcoming: {
                backgroundColor: '#FFF4E7',
            },
            Ongoing: {
                backgroundColor: '#FFF4E7',
            },
        }

        const handleOnClick = () => {
            let arrow_data = {
                paper: papers,
                test_name: heading,
                exam_date_jee: date ? date : '',
            }
            view_drop_click(
                '9_Result_arrow_click',
                arrow_data,
                profileData,
                examType,
            )

            setIsExpanded(!isExpanded)
        }

        const missedExam =
            papers[1]?.btn_txt === 'Missed' && papers[0]?.btn_txt !== 'Missed'

        return (
            <div className={styles.testCard}>
                <div
                    style={IconStyles[status]}
                    className={`${styles.leftCardContainer} ${
                        isExpanded ? styles.expandedLeftCardContainer : ''
                    }`}
                >
                    <img src={lockTypes[status]} alt="success Lock" />
                </div>
                <div className={styles.infoContainer}>
                    <div className={styles.rightCardContainer}>
                        <div>
                            <h3>{heading}</h3>
                            {date === today || firstUpcoming ? (
                                <div className={styles.infoCard}>
                                    <div className={styles.infoItem}>
                                        Exam Date
                                        <span className={styles.infoItemInfo}>
                                            {formattedDate}
                                        </span>
                                    </div>
                                    <hr className={styles.verticalBreak} />
                                    <div className={styles.infoItem}>
                                        Start Time
                                        <span className={styles.infoItemInfo}>
                                            {papers[0].start_time}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <div className={styles.missedExam}>
                                    <p>{formattedDate}</p>
                                    {missedExam && (
                                        <>
                                            <p>I</p>
                                            <p>Paper 2 Missed</p>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                        {status === 'Results' ? (
                            <>
                                <button
                                    onClick={() => handleOnClick()}
                                    style={buttonStyles[status]}
                                    className={styles.testCardButton}
                                    disabled={status !== 'Results'}
                                >
                                    {status}
                                    {status === 'Results' && (
                                        <img
                                            width={25}
                                            height={25}
                                            alt="downArrow"
                                            src={DownArrow}
                                            className={
                                                isExpanded ? styles.rotatedArrow : ''
                                            }
                                        />
                                    )}
                                </button>
                                <button
                                    onClick={() => handleOnClick()}
                                    className={styles.mWebtestCardButton}
                                >
                                    <img
                                        width={24}
                                        height={24}
                                        alt="downArrow"
                                        src={DownArrow}
                                        className={
                                            isExpanded ? styles.rotatedArrow : ''
                                        }
                                    />
                                </button>
                            </>
                        ) : (
                            <div
                                style={buttonStyles[status]}
                                className={styles.testCardStatus}
                            >
                                {status}
                            </div>
                        )}
                    </div>
                    <div
                        className={
                            date === today || firstUpcoming || isExpanded
                                ? styles.bottomCardContainer
                                : styles.bottomCardContainerHidden
                        }
                    >
                        {date === today ||
                            (firstUpcoming && (
                                <div className={styles.infoCardMweb}>
                                    <div className={styles.infoItem}>
                                        Exam Date
                                        <span className={styles.infoItemInfo}>
                                            {formattedDate}
                                        </span>
                                    </div>
                                    <hr className={styles.verticalBreak} />
                                    <div className={styles.infoItem}>
                                        Start Time
                                        <span className={styles.infoItemInfo}>
                                            {papers[0].start_time}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        {isExpanded && (
                            <>
                                {isFinished && (
                                    <p className={styles.isFinishedExam}>
                                        Detailed Result will be available from 6 PM
                                    </p>
                                )}
                                <div className={styles.bottomCardContainerGrid}>
                                    {papers.map((paper, key) => (
                                        <PaperCard
                                            key={key}
                                            heading={paper.name}
                                            buttonLabel={paper.btn_txt}
                                            buttonVariant={paper.btn_txt}
                                            profileData={profileData}
                                            examData={paper}
                                            examDate={date}
                                            test_name={heading}
                                            token={token}
                                            isDisabled={false}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.pageContainer}>
            {isCalendarVisible && (
                <div className={styles.overlay} onClick={handleStickyClick}></div>
            )}
            <div className={styles.leftContainer}>
                <InfoBoard username={studentName} dateObj={examDates} />
            </div>
            <div className={styles.rightContainer}>
                {isLoading ? (
                    <SunspotLoader
                        gradientColors={['#4039d4', '#E0E7FF']}
                        size={'10px'}
                        desktopSize={'10px'}
                        className="m-auto"
                    />
                ) : (
                    <>
                        {' '}
                        {currentSeries ? (
                            <>
                                <div className={styles.breakLine}>
                                    Live Test
                                    <span />
                                </div>
                                <ExamCard
                                    data={currentSeries}
                                    profileData={profileData}
                                    token={token}
                                />
                            </>
                        ) : (
                            !hasPastExams && <Bookmark />
                        )}
                        {mainExam?.length > 0 ? (
                            <>
                                <div className={styles.breakLine}>
                                    Test Series
                                    <span />
                                </div>
                                {mainExam
                                    .filter(
                                        (exam) =>
                                            !currentSeries?.series_name?.includes(
                                                exam?.series_name,
                                            ),
                                    )
                                    .map((index, key) => (
                                        <TestCard
                                            key={key}
                                            date={index.exam_date}
                                            heading={index.series_name}
                                            status={index.status}
                                            papers={index.papers}
                                            token={token}
                                            firstUpcoming={key === firstUpcoming}
                                        />
                                    ))}
                            </>
                        ) : (
                            <div className={styles.noExamsMessage}>
                                <img src={LockGray} alt="lock" />
                                <p>
                                    No exams are available right now
                                    <br /> Please come back later!
                                </p>
                            </div>
                        )}
                    </>
                )}

                <div className={styles.mWebVideo}>
                    <Byjus_Advantage token={token} profileData={profileData} />
                </div>
                <Faq token={token} profileData={profileData} />
            </div>
            {/* Sticky and Calender for mobile only */}
            <div className={styles.stickyStrip}>
                <button
                    className={styles.stickyStripbtn}
                    onClick={handleStickyClick}
                >
                    <div className={styles.stickyInfo}>
                        <div className={styles.strip}>
                            <img src={calendarImage} alt="calender" />
                            <p>Test Series Calender</p>
                        </div>

                        <img
                            width={25}
                            height={25}
                            alt="downArrow"
                            src={DownArrow}
                            className={isCalendarVisible ? '' : styles.rotatedArrow}
                        />
                    </div>
                </button>

                {isCalendarVisible && (
                    <div className={styles.stickyCalendar}>
                        <Calendar
                            dateObj={examDates}
                            currentDate={new Date()}
                            profile={profileData}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default JeeDashboard
